var $6bf8e6753e473c61$exports = {};
$6bf8e6753e473c61$exports = {
    "loading": `\u{5D8}\u{5D5}\u{5E2}\u{5DF}...`,
    "loadingMore": `\u{5D8}\u{5D5}\u{5E2}\u{5DF} \u{5E2}\u{5D5}\u{5D3}...`
};


export {$6bf8e6753e473c61$exports as default};
//# sourceMappingURL=he-IL.mjs.map
